
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/builds/se-team/deli-web-portal-front/sentry.client.config.ts")
            }
          });